import React, { useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/Shared/PageHeader';
import { useLocation } from 'react-router-dom';
import SharedButton from '../../components/Shared/SharedButton';
import CustomSearchDropdown from '../../components/Shared/CustomSearchDropdown';
import { getAllEmployees } from '../../store/slices/EmployeeSlice';
import { CreateNewAttendance, UpdateAttendance } from '../../store/slices/HrSlice';
import { FaCheckDouble } from 'react-icons/fa';

export default function CreateAttendance() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isLoading } = useSelector(state => state.employee);
  const { allEmployees } = useSelector(state => state.employee);
  const { isLoading: loaiding } = useSelector(state => state?.hr);
  const location = useLocation();
  const editData = location?.state?.editingAttendance || null;


  useEffect(() => {
    dispatch(getAllEmployees());
  }, [dispatch]);

  const listEmployees = allEmployees?.data
    ? allEmployees.data.map(employee => ({
      id: employee.id,
      name: `${employee.first_name} ${employee.last_name}`
    }))
    : [];

  // year-month-days
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 10 }, (_, i) => ({
    id: currentYear - i,
    name: (currentYear - i).toString()
  }));
  const monthOptions = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' }
  ];
  const dayOptions = Array.from({ length: 31 }, (_, i) => ({
    id: i + 1,
    name: (i + 1).toString()
  }));

  const initialValues = editData ? {
    id: editData?.id || '',
    employee_id: editData?.employee?.id || '',
    year: editData?.year || '',
    month: editData?.month || '',
    days: editData?.days || ''
  } : {
    employee_id: '',
    year: '',
    month: '',
    days: ''
  };

  const validationSchema = Yup.object({
    employee_id: Yup.number().required(t('required')),
    year: Yup.number().required(t('required')),
    month: Yup.number().required(t('required')),
    days: Yup.number().required(t('required'))
  });

  const onSubmit = async (data, { resetForm }) => {
    try {
      const resultAction = data.id
        ? await dispatch(UpdateAttendance(data))
        : await dispatch(CreateNewAttendance(data));

      if (UpdateAttendance.fulfilled.match(resultAction) || CreateNewAttendance.fulfilled.match(resultAction)) {
        resetForm();
        navigate(-1);
      }
    } catch (error) {
      console.error('Error submitting attendance:', error);
    }
  };

  return (
    <div className="flex flex-col w-full gap-4 max-h-[calc(100vh-150px)]">
      <PageHeader
        title={t(editData ? 'Update Attendance' : 'Create Attendance')}
        showBackBtn
        onBackBtnClick={() => navigate(-1)}
      />

      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit} className="space-y-6">
            <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 w-full'>
              <CustomSearchDropdown
                name='employee_id'
                placeholder={`${t('select')} ${t('employee')}`}
                options={listEmployees}
                label={`${t('employee')} ${t('name')}`}
                value={formik.values.employee_id}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="!w-full !border-gray-300 !bg-gray-100 !h-[30px]"
              />

              <CustomSearchDropdown
                label={t('year')}
                name='year'
                placeholder={`${t('select')} ${t('year')}`}
                options={yearOptions}
                value={formik.values.year}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="!w-full !border-gray-300 !bg-gray-100 !h-[30px]"

              />

              <CustomSearchDropdown
                label={t('month')}
                name='month'
                placeholder={`${t('select')} ${t('month')}`}
                options={monthOptions}
                value={formik.values.month}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="!w-full !border-gray-300 !bg-gray-100 !h-[30px]"

              />

              <CustomSearchDropdown
                label={t('days')}
                name='days'
                placeholder={`${t('select')} ${t('days')}`}
                options={dayOptions}
                value={formik.values.days}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="!w-full !border-gray-300 !bg-gray-100 !h-[30px]"
              />
            </div>

            <div className='flex justify-end gap-2 mt-2'>
              <SharedButton
                type='button'
                icon='pi pi-times'
                buttonType='reset'
                label={t('Cancel')}
                className='cancel-btn'
                onClick={() => {
                  navigate(-1);
                }}
              />
              <SharedButton
                type='submit'
                icon={<FaCheckDouble size={12} className='me-2' />}
                loading={loaiding}
                disabled={loaiding}
                label={t(editData ? 'Update' : 'Submit')}
                className='submit-btn'
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}